  <app-admin-nav-details 
  pageName="Join App Waitlist (Users)" 
  pageMessage="Manage users who joined waitlist"
  >
     <button class="btn btn-toggle" (click)="toggleView()">
      Switch to {{ viewMode === 'card' ? 'Table View' : 'Card View' }}
    </button>
</app-admin-nav-details>
  
  
  <!-- 🃏 Card View -->
  <div *ngIf="viewMode === 'card'" class="card-container">
    <div class="bug-card" *ngFor="let joinAppWaitlist of joinAppWaitlists">
      <div class="card-content">
         <div class="badges-container mb-3">
            <span class="badge priority-badge" [ngClass]="getPreferedContactMethodClass(joinAppWaitlist.preferredContactMethod)" *ngIf="joinAppWaitlist.preferredContactMethod">
              {{ joinAppWaitlist.preferredContactMethod }}
            </span>
            <span class="badge status-badge" [ngClass]="getLeadSourceClass(joinAppWaitlist.leadSource)">
              {{ joinAppWaitlist.leadSource}}
            </span>
          </div>
        <h6 class="mb-2 text-black fs-5">{{ joinAppWaitlist.email }}</h6>
        <div class="card-info">
          <p><strong>Date:</strong> {{ joinAppWaitlist.createdAt | date:'yyyy-MM-dd' }}</p>
        </div>
        <button class="btn btn-view" (click)="viewBug(joinAppWaitlist)">View Bug</button>
      </div>
    </div>
  </div>

  <!-- 📋 Table View -->
  <div *ngIf="viewMode === 'table'" class="table-container">
    <div class="table-responsive">
      <table class="custom-table">
        <thead>
          <tr>
            <th>#</th>
            <th>FirstName</th>
            <th>LastName</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let joinAppWaitlist of joinAppWaitlists; let i = index">
            <td class="text-black">{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
            <td class="text-black">{{ joinAppWaitlist.firstName }}</td>
            <td class="text-black">{{ joinAppWaitlist.lastName }}</td>
            <td class="text-black">{{ joinAppWaitlist.email }}</td>
            <td class="text-black">{{ joinAppWaitlist.phone }}</td>
            <td class="text-black">{{ joinAppWaitlist.createdAt }}</td>
            <td>
              <button class="btn btn-view btn-sm" (click)="viewBug(joinAppWaitlist)">View</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
   <div class="d-flex justify-content-center mt-4">
  <div class="pagination pagination-container" *ngIf="totalPages > 1">
    <button class="btn btn-light prev-btn" [disabled]="pageNumber === 1" (click)="changePage(pageNumber - 1)">
      Previous
    </button>

    <button
      *ngFor="let page of [].constructor(totalPages); let i = index"
      class="btn page-link"
      [ngClass]="{ 'btn-primary': pageNumber === (i + 1), 'btn-light': pageNumber !== (i + 1) }"
      (click)="changePage(i + 1)"
    >
      {{ i + 1 }}
    </button>

    <button class="btn btn-light next-btn" [disabled]="pageNumber === totalPages" (click)="changePage(pageNumber + 1)">
      Next
    </button>
  </div>
  </div>

  <!-- Modal Popup -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()" *ngIf="selectetWaitlist">
      <div class="modal-header border-bottom pb-2">
        <h6 class="m-0" style="color: black">Joined Waitlist User Details</h6>
        <button class="close-btn" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="form-row" style="color: black">
          <div class="col">
            <label><strong>App Name:</strong></label>
            <p >{{selectetWaitlist.appName}}</p>
          </div>
           <div class="col">
              <label><strong>UserId:</strong></label>
              <p>{{selectetWaitlist.id}}</p>
          </div>
        </div>
        <div class="form-row" style="color: black">
          <div class="col">
             <label><strong>First Name:</strong></label>
            <p>{{selectetWaitlist.firstName}}</p>
          </div>
           <div class="col">
              <label><strong>Last Name:</strong></label>
            <p>{{selectetWaitlist.lastName}}</p>
          </div>
        </div>
        <div class="form-group" style="color: black">
          <label><strong>Email:</strong></label>
           <p>{{selectetWaitlist.email}}</p>
        </div>
        <div class="form-row" style="color: black">
          <div class="col">
                <label><strong>Phone:</strong></label>
                <p>{{this.selectetWaitlist.phone | formatNumber}}</p>
          </div>
           <div class="col">
              <label><strong>CreatedAt:</strong></label>
              <p>{{selectetWaitlist.createdAt | date}}</p>
          </div>
        </div>
        <div class="form-group" style="color: black">
          <label><strong>Description:</strong></label>
           <p>{{selectetWaitlist.specificQuestionsOrRequests ? selectetWaitlist.specificQuestionsOrRequests : "N/A"}}</p>
        </div>
       
          <div class="form-group custom-select-wrapper">
            <label><strong>Preferred Contact Method:</strong></label>
            <select [(ngModel)]="selectetWaitlist.preferredContactMethod" class="form-control custom-select" disabled>
              <option value="1">Email</option>
              <option value="2">Text</option>
              <option value="3">Phone</option>
              <option value="4">Phone Call</option>
              <option value="5">Fax</option>
              <option value="6">Mail</option>
              <option value="7">Push Notification</option>
              <option value="8">Whats App</option>
              <option value="9">Insizon App Push Notification</option>
              <option value="10">Google Meets Video Call</option>
            </select>
          </div>
          <div class="form-group custom-select-wrapper">
            <label><strong>Lead Source:</strong></label>
            <select [(ngModel)]="selectetWaitlist.leadSource"  class="form-control custom-select" disabled>
              <option value="1">Social Media</option>
              <option value="2">Word Of Mouth</option>
              <option value="3">Website</option>
              <option value="4">Email Newsletter</option>
              <option value="5">Events</option>
              <option value="6">Search Engines</option>
              <option value="7">Other</option>
            </select>
          </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <!-- <button class="btn btn-primary" (click)="updateBug()" disabled>Update Join Waitlist</button> -->
      </div>
    </div>
  </div>